//data
import useStatuses from "../../../../store/ReactQueries/statuses/useStatus";
import useCategory from "../../../../store/ReactQueries/categories/useCategory";
import useLocations from "../../../../store/ReactQueries/locations/useLocation";
import useCustomers from "../../../../store/ReactQueries/customers/useCustomer";
import usePriorities from "../../../../store/ReactQueries/priorities/usePriority";
import useCompany from "../../../../store/ReactQueries/general/company/useCompany";
import useDepartment from "../../../../store/ReactQueries/departments/useDepartment";
import useContractors from "../../../../store/ReactQueries/contractors/useContractor";
import useAssetTypes from "../../../../store/ReactQueries/assets/assetTypes/useAssetTypes";
import useAssetStatuses from "../../../../store/ReactQueries/assets/assetStatuses/useAssetStatuses";
import useInterventionTypes from "../../../../store/ReactQueries/interventionTypes/useInterventionType";
import useAssetCategories from "../../../../store/ReactQueries/assets/assetCategories/useAssetCategories";
import useAssetActionTypes from "../../../../store/ReactQueries/assets/assetActionTypes/useAssetActionTypes";
import useAssetDepartments from "../../../../store/ReactQueries/assets/assetDepartments/useAssetDepartments";
//addItem
import useAddStatus from "../../../../store/ReactQueries/statuses/useAddStatuses";
import useAddLocation from "../../../../store/ReactQueries/locations/useAddLocations";
import useAddCustomers from "../../../../store/ReactQueries/customers/useAddCustomers";
import useAddCompany from "../../../../store/ReactQueries/general/company/useAddCompany";
import useAddCategories from "../../../../store/ReactQueries/categories/useAddCategories";
import useAddPriorities from "../../../../store/ReactQueries/priorities/useAddPriorities";
import useAddDepartmen from "../../../../store/ReactQueries/departments/useAddDepartments";
import useAddConcractors from "../../../../store/ReactQueries/contractors/useAddContractors";
import useAddAssetTypes from "../../../../store/ReactQueries/assets/assetTypes/useAddAssetType";
import useAddAssetStatuses from "../../../../store/ReactQueries/assets/assetStatuses/useAddAssetStatuses";
import useAddInterventionType from "../../../../store/ReactQueries/interventionTypes/useAddInterventionTypes";
import useAddAssCategories from "../../../../store/ReactQueries/assets/assetCategories/useAddAssetCategories";
import useAddAssetActionType from "../../../../store/ReactQueries/assets/assetActionTypes/useAddAssetActionType";
import useAddAssetDepartment from "../../../../store/ReactQueries/assets/assetDepartments/useAddAssetDepartment";
//updateItem
import useUpdateStatus from "../../../../store/ReactQueries/statuses/useUpdateStatus";
import useUpdateLocation from "../../../../store/ReactQueries/locations/useUpdateLocation";
import useUpdateCategory from "../../../../store/ReactQueries/categories/useUpdateCategory";
import useUpdatePriority from "../../../../store/ReactQueries/priorities/useUpdatePriority";
import useUpdateCustomers from "../../../../store/ReactQueries/customers/useUpdateCustomer";
import useUpdateCompany from "../../../../store/ReactQueries/general/company/useUpdateCompany";
import useUpdateDepartment from "../../../../store/ReactQueries/departments/useUpdateDepartment";
import useUpdateContractors from "../../../../store/ReactQueries/contractors/useUpdateContractors";
import useUpdateAssetType from "../../../../store/ReactQueries/assets/assetTypes/useUpdateAssetType";
import useUpdateAssetStatus from "../../../../store/ReactQueries/assets/assetStatuses/useUpdateAssetStatuses";
import useUpdateAssetCategory from "../../../../store/ReactQueries/assets/assetCategories/useUpdateAssetCategory";
import useUpdateInterventionType from "../../../../store/ReactQueries/interventionTypes/useUpdateInterventionType";
import useUpdateAssetActionType from "../../../../store/ReactQueries/assets/assetActionTypes/useUpdateAssetActionType";
import useUpdateAssetDepartment from "../../../../store/ReactQueries/assets/assetDepartments/useUpdateAssetDepartment";
//deleteItem
import useDeleteStatus from "../../../../store/ReactQueries/statuses/useDeleteStatus";
import useDeleteCustomer from "../../../../store/ReactQueries/customers/useDeleteCustomer";
import useDeletePriority from "../../../../store/ReactQueries/priorities/useDeletePriority";
import useDeleteCategory from "../../../../store/ReactQueries/categories/useDeleteCategory";
import useDeleteLocations from "../../../../store/ReactQueries/locations/useDeleteLocations";
import useDeleteCompany from "../../../../store/ReactQueries/general/company/useDeleteCompany";
import useDeleteContractor from "../../../../store/ReactQueries/contractors/useDeleteContractor";
import useDeleteDepartment from "../../../../store/ReactQueries/departments/useDeleteDepartment";
import useDeleteAssetType from "../../../../store/ReactQueries/assets/assetTypes/useDeleteAssetType";
import useDeleteAssetCategory from "../../../../store/ReactQueries/assets/assetCategories/useDeleteAssetCategory";
import useDeleteInterventionType from "../../../../store/ReactQueries/interventionTypes/useDeleteInterventionTypes";
import useDeleteAssetActionType from "../../../../store/ReactQueries/assets/assetActionTypes/useDeleteAssetActionType";
import useDeleteAssetDepartment from "../../../../store/ReactQueries/assets/assetDepartments/useDeleteAssetDepartment";
//
import useVendors from "../../../../store/ReactQueries/procurements/vendors/useVendors";
import useAddVendors from "../../../../store/ReactQueries/procurements/vendors/useAddVendor";
import useUpdateVendors from "../../../../store/ReactQueries/procurements/vendors/useUpdateVendor";
import useDeleteVendor from "../../../../store/ReactQueries/procurements/vendors/useDeleteVendor";
import useVendorStatus from "../../../../store/ReactQueries/procurements/vendorStatuses/useVendorStatus";
import useAddVendorStatus from "../../../../store/ReactQueries/procurements/vendorStatuses/useAddVendorStatus";
import useUpdateVendorStatus from "../../../../store/ReactQueries/procurements/vendorStatuses/useUpdateVendorStatus";
import useDeleteVendorStatus from "../../../../store/ReactQueries/procurements/vendorStatuses/useDeleteVendorStatus";
import usePurchaseOrderTypes from "../../../../store/ReactQueries/procurements/purchaseOrderTypes/usePurchaseOrderTypes";
import useAddPurchaseOrderType from "../../../../store/ReactQueries/procurements/purchaseOrderTypes/useAddPurchaseOrderType";
import useUpdatePurchaseOrderType from "../../../../store/ReactQueries/procurements/purchaseOrderTypes/useUpdatePurchaseOrderType";
import useDeletePurchaseOrderType from "../../../../store/ReactQueries/procurements/purchaseOrderTypes/useDeletePurchaseOrderType";
import useDeleteAssetStatus from "../../../../store/ReactQueries/assets/assetStatuses/useDeleteAssetStatuses";
interface QueryHooks<T> {
  useQuery: Function;
  useAdd: Function;
  useUpdate: Function;
  useDelete: Function;
}

const getQueryHooks = <T>(fieldName: string): QueryHooks<T> => {
  const queries: Record<string, QueryHooks<any>> = {
    //company details
    company: {
      useQuery: useCompany,
      useAdd: useAddCompany,
      useUpdate: useUpdateCompany,
      useDelete: useDeleteCompany,
    },
    location: {
      useQuery: useLocations,
      useAdd: useAddLocation,
      useUpdate: useUpdateLocation,
      useDelete: useDeleteLocations,
    },
    customer: {
      useQuery: useCustomers,
      useAdd: useAddCustomers,
      useUpdate: useUpdateCustomers,
      useDelete: useDeleteCustomer,
    },
    //ticket
    category: {
      useQuery: useCategory,
      useAdd: useAddCategories,
      useUpdate: useUpdateCategory,
      useDelete: useDeleteCategory,
    },
    contractor: {
      useQuery: useContractors,
      useAdd: useAddConcractors,
      useUpdate: useUpdateContractors,
      useDelete: useDeleteContractor,
    },
    interventionType: {
      useQuery: useInterventionTypes,
      useAdd: useAddInterventionType,
      useUpdate: useUpdateInterventionType,
      useDelete: useDeleteInterventionType,
    },
    status: {
      useQuery: useStatuses,
      useAdd: useAddStatus,
      useUpdate: useUpdateStatus,
      useDelete: useDeleteStatus,
    },
    priority: {
      useQuery: usePriorities,
      useAdd: useAddPriorities,
      useUpdate: useUpdatePriority,
      useDelete: useDeletePriority,
    },
    department: {
      useQuery: useDepartment,
      useAdd: useAddDepartmen,
      useUpdate: useUpdateDepartment,
      useDelete: useDeleteDepartment,
    },
    // asset management
    assetCategory: {
      useQuery: useAssetCategories,
      useAdd: useAddAssCategories,
      useUpdate: useUpdateAssetCategory,
      useDelete: useDeleteAssetCategory,
    },
    assetType: {
      useQuery: useAssetTypes,
      useAdd: useAddAssetTypes,
      useUpdate: useUpdateAssetType,
      useDelete: useDeleteAssetType,
    },
    assetStatus: {
      useQuery: useAssetStatuses,
      useAdd: useAddAssetStatuses,
      useUpdate: useUpdateAssetStatus,
      useDelete: useDeleteAssetStatus,
    },
    assetActionType: {
      useQuery: useAssetActionTypes,
      useAdd: useAddAssetActionType,
      useUpdate: useUpdateAssetActionType,
      useDelete: useDeleteAssetActionType,
    },
    assetDepartment: {
      useQuery: useAssetDepartments,
      useAdd: useAddAssetDepartment,
      useUpdate: useUpdateAssetDepartment,
      useDelete: useDeleteAssetDepartment,
    },
    // procurement
    vendor: {
      useQuery: useVendors,
      useAdd: useAddVendors,
      useUpdate: useUpdateVendors,
      useDelete: useDeleteVendor,
    },
    vendorStatus: {
      useQuery: useVendorStatus,
      useAdd: useAddVendorStatus,
      useUpdate: useUpdateVendorStatus,
      useDelete: useDeleteVendorStatus,
    },
    purchaseOrderType: {
      useQuery: usePurchaseOrderTypes,
      useAdd: useAddPurchaseOrderType,
      useUpdate: useUpdatePurchaseOrderType,
      useDelete: useDeletePurchaseOrderType,
    },
  };

  return queries[fieldName] || queries.company;
};

export default getQueryHooks;
